function initScrollReveal() {
  var els = document.querySelectorAll(
    '.reveal-up:not([data-reveal-bound]), .reveal-zoom:not([data-reveal-bound]), .reveal-slide-left:not([data-reveal-bound]), .reveal-slide-right:not([data-reveal-bound])'
  );
  if (!els.length) return;

  var isDesignMode = window.Shopify && window.Shopify.designMode;

  if (isDesignMode) {
    els.forEach(function (el) {
      el.setAttribute('data-reveal-bound', '');
      el.classList.add('in');
    });
    return;
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('in');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15, rootMargin: '0px 0px -8% 0px' }
  );

  els.forEach(function (el) {
    el.setAttribute('data-reveal-bound', '');
    observer.observe(el);
  });
}

document.addEventListener('DOMContentLoaded', initScrollReveal);

if (window.Shopify && window.Shopify.designMode) {
  document.addEventListener('shopify:section:load', initScrollReveal);
  document.addEventListener('shopify:section:select', initScrollReveal);
  document.addEventListener('shopify:block:select', initScrollReveal);
}
